/* RapidPlas add-to-cart confirmation — Golden Panda / SF035
   The mini-cart drawer is switched off, so the theme's Preact add-to-cart posts
   to /cart/add.js and then has nothing to show. This used to send the shopper
   straight to the cart page; Roy asked for the cart to open only from the cart
   icon (22 Sep 2026), so a cart add now stays on the page and shows a short
   confirmation instead.

   Add to Quote posts to the same endpoint with a _Quote property. It also
   stays on the product page (Roy, 22 Sep 2026) and only changes the wording of
   the confirmation, so a shopper can keep adding items to a quote without
   being pulled away after each one.

   Only /cart/add is matched, so /cart/update.js (used by the delivery locator
   to store the suburb) and /cart.js reads are left alone. */
(function () {
  'use strict';

  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;

  function cartUrl() {
    return window.rpCartUrl || '/cart';
  }

  /* The header badge is driven by the theme's own 'cart.change' event, which
     the compiled cart only emits on the cart page. While the add redirected,
     the full page load refreshed it; staying put means we have to say so
     ourselves. Mirrors what module-cart-count does with the same value, and
     also emits the event for anything else listening (Roy, 22 Sep 2026). */
  function paintCount(count) {
    var els = document.querySelectorAll('#CartCount');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (count === 0) { el.classList.add('hidden'); continue; }
      el.innerText = el.hasAttribute('data-type') ? '(' + count + ')' : String(count);
      el.classList.remove('hidden');
      el.classList.add('inline-block');
    }
  }

  function refreshCount() {
    var url = cartUrl().replace(/\/+$/, '') + '.js';
    originalFetch.call(window, url, { credentials: 'same-origin' })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || typeof c.item_count !== 'number') return;
        paintCount(c.item_count);
        try {
          document.dispatchEvent(new CustomEvent('cart.change', { detail: c.item_count }));
        } catch (e) { /* the badge is already painted */ }
      })
      .catch(function () { /* leave the badge alone on failure */ });
  }

  function isQuoteAdd(body) {
    if (!body) return false;
    try {
      if (typeof body === 'string') return body.indexOf('_Quote') !== -1;
      if (window.FormData && body instanceof FormData) {
        var hit = false;
        body.forEach(function (value, key) {
          if (String(key).indexOf('_Quote') !== -1) hit = true;
        });
        return hit;
      }
      if (window.URLSearchParams && body instanceof URLSearchParams) {
        return body.toString().indexOf('_Quote') !== -1;
      }
    } catch (e) { /* treat as a plain cart add */ }
    return false;
  }

  var styled = false;
  function styleOnce() {
    if (styled) return;
    styled = true;
    var css =
      '.rp-added{position:fixed;left:50%;bottom:24px;transform:translate(-50%,16px);' +
      'display:flex;align-items:center;gap:.6rem;max-width:calc(100vw - 32px);' +
      'padding:.75rem 1rem;border-radius:8px;background:#0f2f22;color:#fff;' +
      'font-size:.9375rem;line-height:1.35;box-shadow:0 8px 24px rgba(0,0,0,.22);' +
      'opacity:0;visibility:hidden;transition:opacity .18s ease,transform .18s ease,visibility .18s;' +
      'z-index:2147483000}' +
      '.rp-added.is-open{opacity:1;visibility:visible;transform:translate(-50%,0)}' +
      '.rp-added__icon{flex:0 0 auto;color:#5ad18f}' +
      '.rp-added__text{flex:1 1 auto}' +
      '.rp-added__link{flex:0 0 auto;color:#fff;text-decoration:underline;font-weight:600;white-space:nowrap}' +
      '.rp-added__link:hover{opacity:.85}' +
      '@media (prefers-reduced-motion: reduce){.rp-added{transition:none}}';
    var tag = document.createElement('style');
    tag.appendChild(document.createTextNode(css));
    document.head.appendChild(tag);
  }

  function toast(quote) {
    styleOnce();
    var el = document.querySelector('[data-rp-added]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'rp-added';
      el.setAttribute('data-rp-added', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML =
      '<svg class="rp-added__icon" width="18" height="18" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Zm3.03 4.72-3.9 3.9a.75.75 0 0 1-1.06 0L4.22 8.28l1.06-1.06 1.32 1.32 3.37-3.37 1.06 1.05Z"/></svg>' +
      '<span class="rp-added__text">' +
      (quote ? 'Added to your quote list' : 'Added to your cart') + '</span>' +
      '<a class="rp-added__link" href="' + cartUrl() + '">' +
      (quote ? 'Review &amp; request quote' : 'View cart') + '</a>';
    // force a reflow so the transition runs on a freshly created node
    void el.offsetWidth;
    el.classList.add('is-open');
    if (el.__rpTimer) clearTimeout(el.__rpTimer);
    el.__rpTimer = setTimeout(function () { el.classList.remove('is-open'); }, 6000);
  }

  function onAdded(body) {
    var quote = isQuoteAdd(body);
    setTimeout(function () { toast(quote); }, 60);
    refreshCount();
  }

  // fetch()
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var body = init && init.body;
      var promise = originalFetch.apply(this, arguments);
      if (CART_ADD.test(url)) {
        promise.then(function (res) {
          if (res && res.ok) onAdded(body);
        }).catch(function () { /* leave the page alone on failure */ });
      }
      return promise;
    };
  }

  // XMLHttpRequest
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__rpCartAdd = CART_ADD.test(url || ''); } catch (e) { this.__rpCartAdd = false; }
    return originalOpen.apply(this, arguments);
  };

  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    if (xhr.__rpCartAdd) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) onAdded(body);
      });
    }
    return originalSend.apply(this, arguments);
  };
})();
